<div class="bar-holder" [ngClass]="{ hidden: !showBarChart }">
  <div class="close" (click)="showBarChart=false">X</div>
  <svg id="accountChart"  width="800" height="490"></svg>
</div>
<loader-pane-fragment [trace]="traceNames.viewAccounts"></loader-pane-fragment>
<ng-container *ngIf="!account">
  <div class="wrap920">
    <h1>Accounts</h1>
    <div class="pending">
        <div class="invite" *ngFor="let acc of invited; trackBy: trackByFn; last as last" [ngClass]="{last:last,processing:accountService.processing[acc.id]}">
            <div class="invited_by" *ngIf="acc.invited_by as sender">
                <photo [data]="sender"></photo><div class="name">{{sender?.firstName + ' ' + sender?.lastName}}  invited you to an account as {{ acc.invited_as_role }}</div>
            </div>
            <div class="account">
                <div class="head">
                    <photo [data]="acc" [size]="36"></photo>
                    <b class="name">{{acc.title}}</b>
                </div>
                <div style="flex:1"></div>
                <div class="btns">
                    <button mat-button (click)="accountService.decline(acc)">Decline</button>
                    <button mat-button color="primary" (click)="accountService.accept(acc)">Accept</button>
                </div>
            </div>
        </div>
    </div>
    <app-account-profile-panel *ngFor="let acc of accountList" [acc]="acc" (visit)="visit($event)" [creating]="go_to" ></app-account-profile-panel>
    <button mat-button class="large" (click)="addAccount()">+ Add an account</button>
  </div>
</ng-container>
<ng-container *ngIf="account && { nAccounts: accountList?.length || 0 } as vars">
  <div class="wrap920">
    <div class="back" routerLink="/accounts"><icon matIcon="arrow_back"></icon> MY ACCOUNT{{ vars.nAccounts > 1 ? 'S' :''}}</div>
    <div class="header_container">
        <div class="header">
            <div class="photo" (mouseenter)="editPhoto=true" (mouseleave)="editPhoto=false">
                <photo [data]="account" [size]="80"></photo>
                <logo-handler 
                  [id]="account.id"
                  [imageData]="{ typeId: account.id, type: 'accounts', subtype: 'logo' }"
                  (uploadStatusChanged)="statusChange($event)"
                ></logo-handler>
                <div class="uploading" *ngIf="wait_for_reload">
                    <mat-progress-spinner [diameter]="40" mode="indeterminate" color="primary"></mat-progress-spinner>
                </div>
            </div>
            <joi-input
              class="name"
              placeholder="Account name..."
              [autoSelect]="true"
              type="textarea"
              [(model)]="account.title"
              (joiChange)="saveTitle(account)"
            ></joi-input >
        </div>
        <div class="file_message">
            <div class="invalid" *ngIf="invalid_file">Invalid file</div>
            <div class="hint" [ngClass]="{show: editPhoto && !invalid_file}">For best results upload a square image.</div>
        </div>
    </div>
    <div class="dataset" *ngIf="!account.docket?.limit" >
      <div class="column">
          <mat-progress-spinner [diameter]="50" *ngIf="!account.docket || !account.docket?.status" mode="indeterminate"></mat-progress-spinner>
          <div class="subscription" *ngIf="account.docket?.status === 'beta'" >
            <b>Beta account:</b> unlimited events
            <div class="next_step_description">You are on a beta version at the moment</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'trial'" >
            <b>Free trial</b> ({{ account.docket?.days_remaining }} day{{ account.docket?.days_remaining === '1' ? '' : 's'}}  remaining)
            <div class="next_step_description">Choose your subscription now to avoid interruptions when your trial&nbsp;expires!</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'fresh'" >
            <b>No subscription selected</b><br />(Free trial pending event creation)
            <div class="next_step_description">To activate your free trial, create an event from the home page.<br />To skip the trial period, please choose your subscription level.</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'custom'" >
            <b>This account is on a custom subscription</b>
            <div class="next_step_description">To change you subscription in any way, please contact your Joi representative.</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'initial'" >
            <b>No subscription selected</b>
            <div class="next_step_description">To activate this account, please choose your subscription level.</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'incomplete'" class="warn">
            <b>Payment is incomplete</b>
            <div class="next_step_description">Once you have validated your payment, your subscription will come into effect.</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'expired'" class="warn">
            <b>Free trial has expired</b>
            <div class="next_step_description">To continue using Joi, please choose your subscription level.</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'canceled'" class="warn">
            <b>Subscription cancelled</b>
            <div class="next_step_description">To continue using Joi, please choose your subscription level.</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'suspended'" class="warn">
            <b>Subscription has expired</b>
            <div class="next_step_description">To continue using Joi, please update your payment method.</div>
          </div>
          <div class="subscription" *ngIf="account.docket?.status === 'active'">
            <b>{{account.docket?.limit}} active event{{account.docket?.limit>1 ? 's' : ''}}</b>
            ({{ account.docket?.subscription_summary }})
            <div class="next_step_description"></div>
          </div>

      </div>
      <div class="column">
          <div class="title2" (click)="debugAccount()">Current usage:</div>
          <div class="desc">
            {{account.docket?.tally || 0}} active event<span *ngIf="account.docket?.tally !== 1">s</span>
          </div>
          <div class="percent" *ngIf="account.docket?.limit"><div class="baseline"></div><div class="bar" [ngStyle]="{width: account.docket?.limit==0 ? 0 : (account.docket?.tally/account.docket?.limit*100 + '%')}"></div></div>
      </div>
      <div *ngIf="accountService.plans?.costings && account.docket?.status != 'custom' && account.is_admin">
        <button mat-button color="primary" (click)="openPayments()">Choose subscription</button>
      </div>
    </div>
    <div class="dataset" *ngIf="account.docket?.limit > 0 && account.admin.includes(userService.uid)" >
        <div class="column">
            <h5>Subscription:</h5>
            <div class="desc" *ngIf="account.docket?.status === 'beta'"><b>{{account.docket?.limit || 'Unlimited'}} active event{{account.docket?.limit === 1 ? '' : 's'}}</b> (beta period)</div>
            <div class="desc" *ngIf="account.docket?.status !== 'beta'"><b>{{account.docket?.limit || '0'}} active event{{account.docket?.limit === 1 ? '' : 's'}}</b></div>
            <div class="desc"><span *ngIf="accountService.plans?.costings" class="text_link" (click)="openPayments('subscription')">Change</span></div>
        </div>
        <div class="column">
          <h5>Payment method</h5>
          <div class="desc" *ngIf="account.docket?.methods.length > 0
            && account.docket?.active_method_index >= 0
            && account.docket?.methods[account.docket?.active_method_index]">
              {{account.docket?.methods[account.docket?.active_method_index].brand}}
              &nbsp;
              &bull;&bull;&bull;&bull;&nbsp;
              &bull;&bull;&bull;&bull;&nbsp;
              &bull;&bull;&bull;&bull;&nbsp;
              {{account.docket?.methods[account.docket?.active_method_index].last4}}
          </div>
          <div class="desc"><span class="text_link" *ngIf="accountService.plans?.costings" (click)="openPayments('method')">
            {{account.docket?.methods.length > 0
              && account.docket?.active_method_index >= 0
              && account.docket?.methods[account.docket?.active_method_index]
                ? 'Change' : 'Add payment method'}}
          </span></div>
        </div>
        <div class="column">
            <h5>Next billing date</h5>
            <div class="desc">{{account.docket?.expiration?.toDate() | date}}</div>
        </div>
        <div class="column">
            <h5>Current usage:</h5>
            <div class="desc">{{account.docket?.tally || 0}}
              <span *ngIf="account.docket?.limit">
                of {{account.docket?.limit}} active event<span *ngIf="account.docket?.limit !== 1">s</span>
              </span>
              <span *ngIf="!account.docket?.limit">
                active event<span *ngIf="account.docket?.tally">s</span>
              </span>
            </div>
            <div class="percent" *ngIf="account.docket?.limit"><div class="baseline"></div><div class="bar" [ngStyle]="{width: account.docket?.limit==0 ? 0 : (account.docket?.tally/account.docket?.limit*100 + '%')}"></div></div>
        </div>
        <!--
        <div class="column">
            <h5>Storage</h5>
            <div class="desc">{{storage_used(account.id) | fileSize}} of {{storage_limit(account.id) | fileSize:0}} </div>
            <div class="percent"><div class="baseline"></div><div class="bar" [ngStyle]="{width: storage_limit(account.id)==0 ? 0 : (storage_used(account.id)/storage_limit(account.id)*100 + '%')}"></div></div>
          <div class="desc"><span class="link" (click)="openPayments('storage')">Change</span></div>
        </div>
        -->
    </div>
    <div class="dataset whole history" *ngIf="account.docket?.reciepts && account.admin.includes(userService.uid)">
        <div class="header" [ngClass]="{show:show_payment_history}">
            <h3>Payment History</h3><icon (click)="togglePaymentHistory()" icon="expand_24px" [ngClass]="{show: show_payment_history}"></icon>
        </div>
        <div class="payment_history_content" [@drop]="show_payment_history ? 'expand' : 'collapse' ">
          <div class="invoice" *ngFor="let invoice of invoices">
            <div class="">
              <div class="invoice_date">
                {{ invoice.created * 1000 | date }}
                <span class="paid" *ngIf="invoice.paid"> - Paid {{invoice.currency.toUpperCase()}}{{ invoice.amount_paid/100 | currency:invoice.currency.toUpperCase(): 'symbol-narrow' : '1.2'  }}</span>
              </div>
              <div class="subscription_inv_num">Invoice number: {{ invoice.number }} </div>
            </div>
            <div class="lines">
              <div  *ngFor="let line of invoice.lines.data">
                <div class="subscription_period">Subscription period: {{ line.period.start * 1000 | date}} - {{ line.period.end * 1000 | date}}</div>
                <div class="">{{ line.description}}</div>
              </div>
              <div *ngIf="invoice.discount">
                <div>{{invoice.discount.coupon.name}}</div>
              </div>
            </div>
            <div class="cloud_download" *ngIf="invoice.amount_paid > 0">
              <mat-spinner *ngIf="loading_receipt[invoice.charge]" [diameter]="20" color="primary" ></mat-spinner>
              <icon *ngIf="!loading_receipt[invoice.charge]" (click)="downloadInvoice(invoice.charge, invoice.id)" matIcon="cloud_download"></icon>
            </div>

          </div>
          <div class="more_button text_link" (click)="loadInvoices()" *ngIf="has_more_invoices">More</div>
        </div>
        <mat-progress-bar [mode]="'indeterminate'" *ngIf="loading_invoices"></mat-progress-bar>
    </div>
    <div class="dataset whole last">
        <div class="header show">
            <h3>Users <span class="num">({{ account.users?.length }})</span></h3>
            <div class="invite text_link" *ngIf="account.is_admin || account.is_exec" (click)="invite(account)"><icon matIcon="person_add"></icon> Invite user to account</div>
        </div>
        <div class="users">
            <div class="user" *ngFor="let u of account.userInfo; index as idx" (click)="viewProfile($event, u)">
                <photo [data]="u" [size]="36"></photo>
                <div class="name">
                  <b *ngIf="u.status=='invited'">Invited</b>
                  <b *ngIf="u.status=='sending'">Sending...</b>
                  <div [ngClass]="{invited: u.status=='invited' || u.status=='sending'}">
                    {{u.firstName + ' ' + u.lastName}}
                    <span class="owner" *ngIf="(account.owner && u.uid === account.owner) || (!account.owner && u.uid === account.created.creatorUid)"> (Account Owner)</span>
                  </div>
                </div>
                <div style="flex:1"></div>
                <div class="role">{{ RoleNames[u.role]}}</div>
                <div class="action-{{idx}} more noProfile"  *ngIf="account.is_admin || account.is_exec" [matMenuTriggerFor]="userEdit"><icon class="noProfile" matIcon="more_vert"></icon></div>
                <mat-menu #userEdit="matMenu" xPosition="before">
                    <button mat-menu-item [disabled]="u.uid === userService.uid || !u.uid || u.uid === account.owner || (account.is_exec && u.role === 'admin')" (click)="permission($event, u, account, 'action-'+idx)">Change Permissions</button>
                    <button mat-menu-item *ngIf="(!account.owner || u.uid !== account.owner)
                      && (account.owner || u.uid !== account.created.creatorUid)
                      && u.uid !== userService.uid
                      " (click)="remove($event, u, account, 'action-'+idx)">Remove Access</button>
                    <button mat-menu-item *ngIf="(!account.owner || u.uid !== account.owner)
                      && (account.owner || u.uid !== account.created.creatorUid)
                      && u.uid === userService.uid
                      " (click)="remove($event, u, account, 'action-'+idx)">Leave Account</button>
                    <button mat-menu-item *ngIf="
                      u.role === 'admin'
                      && u.uid
                      && u.status !== 'invited'
                      && account.is_admin
                      && account.docket?.stripeId
                      && (!account.owner || u.uid !== account.owner)
                      && (account.owner || u.uid !== account.created.creatorUid)
                      " (click)="makeOwner(account.id, u.uid)">Make Account Owner</button>
                </mat-menu>
            </div>
        </div>

    </div>
    <div *ngIf="!account.docket?.tally && !!status && !['custom', 'active'].includes(status) && account.is_admin" class="delete_account_area">
      <button mat-button class="text_link grey" [disabled]='is_deleting[account.id]' (click)="openDeleteAccount($event, account.id)">Delete account</button>
      <mat-progress-spinner *ngIf="is_deleting[account.id]" [diameter]="25" mode="indeterminate" color="primary"></mat-progress-spinner>
    </div>
  </div>
</ng-container>



